import { useState } from 'react';
import AppliedLeaves from './AppliedLeaves';
import RemainingLeaves from './RemainingLeaves';
import { theme } from 'app/Theme';
import { Box, styled } from '@mui/material';
import dayjs from 'dayjs';
import YearPicker from 'common/components/YearPicker';
import { ContentContainer } from '@libComponents';

const StyledInputWrapper = styled(Box)(({ theme: { spacing } }) => ({
    width: '150px',
    marginLeft: 'auto',
    marginRight: '20px'
}));

const LeaveManagement = () => {

    const [year, setYear] = useState(new Date().getFullYear());

    const handleYearChange = (value) => {
        setYear(dayjs(value).year());
    };
    return (
        <ContentContainer
            title="Leaves Details"
            headerBg={theme.palette.background.mainHeader}
            AdornmentComponent={
                <StyledInputWrapper>
                    <YearPicker
                        onChange={handleYearChange}
                        value={year.toString()}
                    />
                </StyledInputWrapper>
            }
        >
            <Box sx={{ m: 3, mb: 0, width: 'calc(100% - 46px)' }}>
                <RemainingLeaves year={year} />
                <AppliedLeaves year={year} />
            </Box>
        </ContentContainer>
    )
}

export default LeaveManagement;